/**
 * useExpedienteIdentity
 * Carga la sección Identidad (§4.2) bajo demanda (enabled controlado por el caller).
 */
import { useQuery } from '@tanstack/react-query';
import { getExpedienteIdentity } from '@/services/expedientes.service';
import { PARTNER_ID } from '@/constants';

export function useExpedienteIdentity(directoryId: string | undefined, enabled: boolean) {
  const query = useQuery({
    queryKey: ['expedientes', 'identity', directoryId, PARTNER_ID],
    queryFn: () => getExpedienteIdentity(directoryId!, PARTNER_ID),
    enabled: Boolean(directoryId) && enabled,
  });

  return {
    identity: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
